module.exports = __webpack_public_path__ + "json/buildings-3.json?79a218533c4691d728071c56e2384fdc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-3.json
// module id = 1722
// module chunks = 3